<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Verificadores</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <k-table
          @crear="crear"
          @editar="editar"
          @eliminar="eliminar"
          :createButton="puede_crear_verificador"
          :editButton="puede_editar_verificador"
          :deleteButton="puede_eliminar_verificador"
          :path="path"
          ref="listaVerificadores"
          :columns="[
            {
              display: '# Identificación',
              value: 'numero_identificacion',
            },
            {
              display: 'Nombre/Descripción',
              value: 'descripcion',
            },
            {
              display: 'Dirección',
              value: 'direccion',
            },
            {
              display: 'Teléfonos',
              value: 'telefonos',
            },
            {
              display: 'Correos',
              value: 'correos',
            },
            {
              display: 'Creador',
              value: 'creador.nombre',
            },
            {
              display: 'Creación',
              value: 'created_at',
            },
            {
              display: 'Modificador',
              value: 'modificador.nombre',
            },
            {
              display: 'Modificación',
              value: 'updated_at',
            }
          ]"
        ></k-table>
      </div>
    </div>
    <modal
      name="verificador"
      height="auto"
      width="70%"
      scrollable
      adaptive
      resizable
      reset
    >
      <verificador
        v-model="selectedVerificador"
        @saved="verificadorSaved"
        @cancelar="cancelar"
        ref="verificador"
      ></verificador>
    </modal>
  </div>
</template>

<script>
import Verificador from "./Verificador.vue";
export default {
  components: {
    Verificador,
  },
  props: {
    puede_crear_verificador: {
      type: Boolean,
      required: false,
    },
    puede_editar_verificador: {
      type: Boolean,
      required: false,
    },
    puede_eliminar_verificador: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    cancelar: function () {
      this.$modal.hide("verificador");
    },
    crear: function () {
      this.selectedVerificador = {
        descripcion: "",
        direccion: "",
        telefonos: "",
        correos: "",
        id: "",
        _method: undefined,
        numero_identificacion: "",
      };
      this.$modal.show("verificador");
    },
    verificadorSaved: function () {
      this.$refs.listaVerificadores.loadRows();
      this.$modal.hide("verificador");
    },
    editar: function (verificador) {
      this.selectedVerificador = {
        descripcion: verificador.descripcion,
        direccion: verificador.direccion,
        telefonos: verificador.telefonos,
        correos: verificador.correos,
        id: verificador.id,
        _method: "PUT",
        numero_identificacion: verificador.numero_identificacion,
      };
      this.$modal.show("verificador");
    },
    eliminar: function (verificador) {
      let estado = verificador.estado;
      let accion = estado == "I" ? "re-activar" : "inactivar";
      swal({
        title: "¿Desea " + accion + " el verificador seleccionado?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/logistica/verificadores/" + verificador.id, {
              _method: "DELETE",
            })
            .then(() => {
              swal("Proceso realizado exitósamente.", "Realizado", "success");
              this.$refs.listaVerificadores.loadRows();
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
  },
  data: function () {
    return {
      selectedVerificador: null,
      path: url + "/logistica/verificadores",
    };
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/verificadores/ListaVerificadores.vue